import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { PartnerLibraryPage } from '@/features/partner/library-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/partner/library/'
)({
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'team_leader', 'finance'])
    await requireActiveSubscription()
  },
  component: PartnerLibraryPage,
})
